import SettingBase from '../settings/util/SettingBase'

class UsersController extends SettingBase {
  constructor($state) {
    'ngInject';
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'users'
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-users']) {
      this.hasACL[this.acl['setting-users'][key]] = true;
    }
  }
}
UsersController.$inject = ['$state']

export default UsersController;


// WEBPACK FOOTER //
// ./client/app/components/users/users.controller.js